function addMonths (isoDate, months) {
  const [y, m, d] = isoDate.split('-').map(Number)
  const date = new Date(y, m - 1 + months, 1)
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
  const day = Math.min(d, lastDay)
  const out = new Date(date.getFullYear(), date.getMonth(), day)
  return out.toISOString().slice(0, 10)
}

export function newRecorrenciaGrupoId () {
  return `rg_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`
}

export function newRecebivelId () {
  return `r_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`
}

/**
 * @param {{ valor, descricao, dataInicio, repeticoes?: number|null, sempre?: boolean }}
 */
export function generateRecebiveisMensais ({ valor, descricao, dataInicio, repeticoes, sempre }) {
  const count = sempre ? 12 : Math.max(2, Math.min(120, Number(repeticoes) || 2))
  const grupoId = newRecorrenciaGrupoId()
  const items = []
  for (let i = 0; i < count; i++) {
    items.push({
      id: newRecebivelId(),
      valor: Number(valor),
      descricao: descricao || '',
      dataVencimento: addMonths(dataInicio, i),
      pago: false,
      dataPagamento: null,
      recorrenciaGrupoId: grupoId,
      recorrenciaIndice: i + 1,
      recorrenciaTotal: sempre ? null : count,
      recorrenciaSempre: !!sempre
    })
  }
  return items
}

export function recorrenciaBadge (item) {
  if (!item.recorrenciaGrupoId) return null
  if (item.recorrenciaSempre) return 'mensal'
  if (item.recorrenciaTotal) return `${item.recorrenciaIndice}/${item.recorrenciaTotal}`
  return null
}
